import Immutable from 'immutable';
import reducerCreator from '../../tools/reducer-creator';
import * as types from '../../actions/user-activation/types';
import {userActivationCodeStateKeys} from '../../constants/user-activation';

const initialState = Immutable.fromJS({
  [userActivationCodeStateKeys.isLoading]: false,
  [userActivationCodeStateKeys.workflowState]: undefined,
  [userActivationCodeStateKeys.userApplicationIdForRedirect]: undefined
});

export default reducerCreator(initialState, {
  [types.USER_ACTIVATION_SET_CONFIRM_USER_ACTIVATION_LOADING]: (state, {isLoading}) => state.set(userActivationCodeStateKeys.isLoading, isLoading),
  [types.USER_ACTIVATION_SET_USER_ACTIVATION_WORKFLOW_STATE]: (state, {workflowState}) => state.set(userActivationCodeStateKeys.workflowState, workflowState),
  [types.USER_ACTIVATION_RESET_CONFIRM_USER_ACTIVATION_STATE]: () => initialState,
  [types.USER_ACTIVATION_SET_USER_APPLICATION_ID_FOR_REDIRECT]: (state, {applicationId}) => state.set(userActivationCodeStateKeys.userApplicationIdForRedirect, applicationId)
});


// WEBPACK FOOTER //
// ./src/reducers/user-activation/confirm-user-activation.js